export const if6CssPrefix = 'immobilien';
